import { render } from "./RotX.vue?vue&type=template&id=6a80c372"
import script from "./RotX.vue?vue&type=script&lang=js"
export * from "./RotX.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__